import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import Notification from '../../../Notifications/Notification';
import SystemNotification from '../../../SystemNotification';
import AddToFaveIcon from '../../../Icons/AddedToFav';
import ErrorIcon from '../../../Icons/CloseBold';
export var GroupAddedNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, success = _a.success, deviation = _a.deviation, needsVote = _a.needsVote, username = _a.group.username;
    var t = useTranslation().t;
    var group = username || t('common.group');
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
            iconComponent: success ? AddToFaveIcon : ErrorIcon,
            backgroundDeviation: deviation,
        } }, success ? (
    // prettier-ignore
    React.createElement(Trans, { i18nKey: "addToGroup.notification." + (needsVote ? 'suggested' : 'added') },
        "Added to ",
        React.createElement("a", { href: username && Url.userLink(username) }, { group: group }))) : (t("addToGroup.notification.fail." + (needsVote ? 'suggested' : 'added')))));
};
GroupAddedNotification.displayName = 'GroupAddedNotification';
export default GroupAddedNotification;
//# sourceMappingURL=GroupAddedNotification.js.map